<template>
  <div class="page">
    <scanner
      ref="scanner"
      page-title="Перемещение на отгрузку"
      title="VIN-номер"
      @input="findVin"
    />
    <div class="page__wrapper">
      <app-loader v-if="loader" />
      <v-card
        v-for="it in documents"
        v-else
        :id="it.id"
        :key="it.id"
        :to="{
          name: 'CarsByDocument',
          params: { id: it.id }
        }"
        :class="{'card-highlighted': documentSearchedId === it.id}"
        elevation="1"
        :color="getDocumentColor(it)"
        class="card-custom rows-height-3"
        ripple
      >
        <v-card-text class="text-transform-none">
          {{ it.description }} №{{ it.ttn.number }} <br>
          от {{ it.ttn.date | parseDate }}, Автовоз №{{ it.ttn.trackNumber }}
        </v-card-text>
      </v-card>
    </div>
    <div
      v-if="!isScannerShown"
      class="page__actions justify-start"
    >
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.push('/navigation')"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </div>
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
  </div>
</template>

<script>
import Scanner from '@/components/Scanner.vue';
import ResultModal from '@/components/ResultModal.vue';
import { mapState } from 'vuex';

export default {
  name: 'MovementShipping',
  components: {
    Scanner,
    ResultModal,
  },
  data: () => ({
    loader: true,
    documents: [],
    documentSearchedId: null,
    errorModal: false,
    errorText: '',
  }),
  computed: {
    ...mapState(['isScannerShown']),
  },
  created() {
    this.getDocuments();
  },
  methods: {
    async getDocuments() {
      const { data } = await this.$http.get('MobileOperatorInterface/MovementShipping/Documents').catch((e) => {
        this.onErrorHandler(e);
      }).finally(() => {
        this.loader = false;
      });
      this.documents = data;
    },
    getDocumentColor(it) {
      if (it.status === 'ВРаботе') {
        return 'blue lighten-5';
      }

      if (it.status === 'Выполнена') {
        return 'success lighten-4';
      }

      return 'yellow lighten-4';
    },
    findVin(vin) {
      this.documentSearchedId = this.documents.find((it) => it.vins.includes(vin))?.id;
      const scrollTarget = document.getElementById(this.documentSearchedId);
      this.$vuetify.goTo(scrollTarget, {
        offset: 100,
      });
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>

<style lang="scss">
.rows-height-3 {
  min-height: 98px;
}

.v-application .v-card.card-highlighted {
  border: 1px solid red !important
}
</style>
